import React from "react";
import { useReferalProgramsDataContext } from "@/store/ReferalProgramsProvider";
import { FlexColumn, FlexRow } from "@/ui/FlexContainer/FlexContainer";
import Typography from "@/ui/Typography/Typography";
import { ArrowIcon } from "@/assets/icons";
import { useNavigate } from "react-router-dom";
import { parsDate, activeReferalProgramsThisMonth } from "@/utils/helpers";
import { InstructionBlock } from "@/components/InstructionBlock/InstructionBlock";
import { dataTrigger } from "@/analytics";
import { useUserInfoStore } from "@/store/userInfoStore";
import cls from "./styles.module.scss";

type TariffType = "Авто" | "Грузовой" | "Пеший" | "Мото" | "Такси" | "Еда";

const icons: Record<TariffType, string> = {
  Авто: "🚗",
  Грузовой: "🚚",
  Пеший: "🚲",
  Мото: "🏍️",
  Такси: "🚕",
  Еда: "🍕",
};

const PROGRAM_TRIGGERS = {
  delivery: "ref.conditions.program_delivery",
  taxi: "ref.conditions.program_taxi",
  eats: "ref.conditions.program_eats",
} as const;

export const ConditionsList = () => {
  const navigate = useNavigate();
  const { referalPrograms } = useReferalProgramsDataContext();
  const serviceType = useUserInfoStore((s) => s.serviceType);

  const filteredReferalPrograms = activeReferalProgramsThisMonth(
    referalPrograms
  );

  const selectCondition = (conditionId: number) => {
    navigate(`/conditions/${conditionId}`);
  };
  const programTrigger = PROGRAM_TRIGGERS[serviceType ?? "eats"];

  return (
    <FlexColumn gap={28}>
      <div className={cls.header}>
        <button
          type="button"
          {...dataTrigger("ref.conditions.back")}
          className={cls.backBtn}
          onClick={() => navigate(-1) ?? navigate("/")}
        >
          <ArrowIcon />
        </button>
        <Typography variant="h4">Условия</Typography>
      </div>

      <FlexColumn gap={12}>
        <InstructionBlock />

        {filteredReferalPrograms && filteredReferalPrograms.length > 0 ? (
          <FlexColumn gap={10} className={cls.refProgramsList}>
            {filteredReferalPrograms.map((elem) => (
              <FlexRow
                key={elem.id}
                gap={14}
                alignItems="flex-start"
                className={cls.refProgram}
                role="button"
                {...dataTrigger(programTrigger)}
                onClick={() => selectCondition(elem.id)}
              >
                <div className={cls.tariffIcon}>
                  {icons[elem.tariff as TariffType] || "🚗"}
                </div>
                <FlexColumn gap={4} className={cls.conditionsList}>
                  <Typography className={cls.conditionTitle}>
                    {elem.name}
                  </Typography>

                  <FlexRow justifyContent="space-between">
                    <Typography className={cls.date}>
                      {parsDate(elem?.msk_start_date, elem?.msk_end_date)}
                    </Typography>

                    <FlexRow gap={8}>
                      <Typography className={cls.conditionAmount}>
                        {(elem.total_step_1_amount ?? 0).toLocaleString(
                          "ru-RU"
                        )}{" "}
                        ₽
                      </Typography>
                      <div className={cls.arrowBtn}>→</div>
                    </FlexRow>
                  </FlexRow>
                </FlexColumn>
              </FlexRow>
            ))}
          </FlexColumn>
        ) : (
          <Typography variant="h4">
            Нет активных реверальных програм в этом месяце
          </Typography>
        )}
      </FlexColumn>
    </FlexColumn>
  );
};
